var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorreoMorado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.5 4.45947L10 11.3345L2.5 4.45947H17.5Z",
    fill: "#7032D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.45947H17.5V15.0845C17.5 15.2502 17.4342 15.4092 17.3169 15.5264C17.1997 15.6436 17.0408 15.7095 16.875 15.7095H3.125C2.95924 15.7095 2.80027 15.6436 2.68306 15.5264C2.56585 15.4092 2.5 15.2502 2.5 15.0845V4.45947Z",
    stroke: "#7032D8",
    strokeWidth: 0.740741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.45947L10 11.3345L2.5 4.45947",
    stroke: "#7032D8",
    strokeWidth: 0.740741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreoMorado);
export default __webpack_public_path__ + "static/media/Correo_morado.0f06ef900c9fb2a26b23f4e5ec015679.svg";
export { ForwardRef as ReactComponent };